module.exports = __webpack_public_path__ + "img/ig-banner.5c1c8938.jpg";